import { isEmpty } from 'lodash';
import { ACTIONS } from '../actions/auth.actions';

const initialState = {
    isLoading: false,
    user: {
        id: null,
        member: null,
    },
};

export default function (st, action)
{
    const state = isEmpty(st) ? initialState : st;

    switch (action.type)
    {
        case ACTIONS.RETRIEVED_USER:
            state.user = {
                ...state.user, id: action.payload.id, member: action.payload.member,
            };
            break;
        case ACTIONS.LOADING:
            state.isLoading = action.payload;
            break;
        default:
            break;
    }

    return state;
}
